module.exports = __webpack_public_path__ + "img/commission-success.e6be8331.svg";